import React from "react";
import { altColor } from "../../utils/constants";

export default function WelcomeImage3({ color = altColor }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="89" height="205" viewBox="0 0 89 205">
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rechteck_30"
            data-name="Rechteck 30"
            width="89"
            height="205"
            transform="translate(541 3356)"
            fill="#fff"
            stroke="#707070"
            strokeWidth="1"
          />
        </clipPath>
      </defs>
      <g
        id="Gruppe_maskieren_6"
        data-name="Gruppe maskieren 6"
        transform="translate(-541 -3356)"
        clipPath="url(#clip-path)"
      >
        <g id="Ebene_2" data-name="Ebene 2" transform="translate(537.18 3338.998) rotate(26)">
          <g id="OBJECTS" transform="translate(0.004 0)">
            <path
              id="Pfad_275"
              data-name="Pfad 275"
              d="M82.832,256.841c0,2.392.076,4.878.127,7.4h23.065c.044-2.753.076-5.4.1-7.872.07-6.712.082-12.237.076-15.675v-3.806L82.68,236.63v5.36C82.7,245.676,82.743,250.96,82.832,256.841Z"
              transform="translate(-30.234 -86.521)"
              fill="#053a3d"
            />
            <path
              id="Pfad_276"
              data-name="Pfad 276"
              d="M82.69,244.324c0,3.692.057,8.976.146,14.857a115.6,115.6,0,0,0,23.294-.476c.07-6.712.082-12.237.076-15.675Z"
              transform="translate(-30.237 -88.862)"
              fill="#000b29"
            />
            <path
              id="Pfad_277"
              data-name="Pfad 277"
              d="M37.065,251.527c0,3.762.07,8.063.146,12.687H60.283c.051-2.715.1-5.392.14-7.955.076-5.5.121-10.448.14-14s0-5.658,0-5.658l-23.535.254v6.692C37.008,245.779,37.046,248.469,37.065,251.527Z"
              transform="translate(-13.539 -86.511)"
              fill="#053a3d"
            />
            <path
              id="Pfad_278"
              data-name="Pfad 278"
              d="M37,246.828c0,2.22,0,4.91.032,7.968a144.343,144.343,0,0,0,23.357,4.745c.076-5.5.121-10.448.14-14Z"
              transform="translate(-13.531 -89.779)"
              fill="#000b29"
            />
            <path
              id="Pfad_279"
              data-name="Pfad 279"
              d="M80.987,27.572s3.7-3.571,3.692-7.092-2.423-2.487-3.692-5.773-5.075-5.284-7.2-4.885S67.266,2.052,61.265,3.492,55.784,12.633,53.2,13.749s-1.865,5.709-.5,6.731,1.941,5.227,2.7,5.132S80.987,27.572,80.987,27.572Z"
              transform="translate(-18.822 -1.215)"
              fill="#053a3d"
            />
            <path
              id="Pfad_280"
              data-name="Pfad 280"
              d="M56.006,40.523s-2.328-3.108-4.06-.539.717,10.15,4.961,8.3Z"
              transform="translate(-18.791 -14.248)"
              fill="#7b4b2a"
            />
            <path
              id="Pfad_281"
              data-name="Pfad 281"
              d="M56.48,47.538a.362.362,0,0,1-.349-.26,5.464,5.464,0,0,0-3.108-3.3.362.362,0,1,1,.254-.672,6.158,6.158,0,0,1,3.546,3.806.349.349,0,0,1-.247.438A.247.247,0,0,1,56.48,47.538Z"
              transform="translate(-19.29 -15.821)"
              fill="#573719"
            />
            <path
              id="Pfad_282"
              data-name="Pfad 282"
              d="M54.555,47.14a.3.3,0,0,1-.19-.057.355.355,0,0,1-.108-.495A3.368,3.368,0,0,1,55.6,45.5a.368.368,0,0,1,.476.184.362.362,0,0,1-.184.476,2.626,2.626,0,0,0-1.034.818.368.368,0,0,1-.3.159Z"
              transform="translate(-19.82 -16.628)"
              fill="#573719"
            />
            <path
              id="Pfad_283"
              data-name="Pfad 283"
              d="M96.014,40.523s2.334-3.108,4.066-.539-.717,10.15-4.961,8.3Z"
              transform="translate(-34.782 -14.248)"
              fill="#7b4b2a"
            />
            <path
              id="Pfad_284"
              data-name="Pfad 284"
              d="M96.372,47.548a.355.355,0,0,0,.343-.26,5.481,5.481,0,0,1,3.108-3.3.355.355,0,0,0,.209-.463.362.362,0,0,0-.463-.209,6.179,6.179,0,0,0-3.546,3.806.362.362,0,0,0,.254.438.247.247,0,0,0,.1-.013Z"
              transform="translate(-35.108 -15.83)"
              fill="#573719"
            />
            <path
              id="Pfad_285"
              data-name="Pfad 285"
              d="M99.548,47.139a.324.324,0,0,0,.2-.057.362.362,0,0,0,.108-.495A3.356,3.356,0,0,0,98.5,45.5a.355.355,0,0,0-.469.184.362.362,0,0,0,.178.476,2.62,2.62,0,0,1,1.059.818A.355.355,0,0,0,99.548,47.139Z"
              transform="translate(-35.835 -16.627)"
              fill="#573719"
            />
            <path
              id="Pfad_286"
              data-name="Pfad 286"
              d="M80.306,63.81v7.543s-2.252,3.844-5.3,4.111S69.3,72.152,69.3,72.152V64.337Z"
              transform="translate(-25.341 -23.332)"
              fill="#935d37"
            />
            <path
              id="Pfad_287"
              data-name="Pfad 287"
              d="M80.288,63.81v3.349c-2.043,2.265-5.671,2.829-11.038,2.036V64.337Z"
              transform="translate(-25.323 -23.332)"
              fill="#7b4b2a"
            />
            <path
              id="Pfad_288"
              data-name="Pfad 288"
              d="M83.572,27.785a72.417,72.417,0,0,1-.983,9.515c-.14.736-.292,1.421-.469,2.036-1.586,5.576-5.563,15.11-16.684,11.12-4.91-1.751-7.187-7.225-8.2-12.789a54.016,54.016,0,0,1-.742-10.308,7.872,7.872,0,0,1,4-6.718c6.566-3.724,13.493-2.334,18.054-.584A7.866,7.866,0,0,1,83.572,27.785Z"
              transform="translate(-20.652 -6.686)"
              fill="#935d37"
            />
            <path
              id="Pfad_289"
              data-name="Pfad 289"
              d="M57.67,48.6s1.078,6.426,2.112,8.773,3.806,2.785,4.853,4.764c1.491,2.829,3.762,5.075,7.5,3.7,3.108-1.135,2.969-2.721,4.713-3.952,2.988-2.112,4.441-4.441,4.586-6.344a67.555,67.555,0,0,1,1.6-7.3l-1.6-.114A41.023,41.023,0,0,1,79.181,52.1c-1.358-2.975-7.86-.818-7.86-.818l-1.269.4-1.269-.4s-6.572-2.062-7.872,1.04a11.672,11.672,0,0,1-1.732-4.035Zm12.414,4.085c7.454-1.269,6.122,3.083,6.071,3.242h0a7.7,7.7,0,0,1-1.535,1.161c-2.886,1.561-3.172,1.319-4.339,1.37A8.538,8.538,0,0,1,65.9,57.261a12.592,12.592,0,0,1-2.087-1.6S62.65,51.679,70.084,52.681Z"
              transform="translate(-21.089 -17.595)"
              fill="#053a3d"
            />
            <path
              id="Pfad_290"
              data-name="Pfad 290"
              d="M69.112,42.159c0,.806-.412,1.459-.926,1.459s-.926-.634-.926-1.459.412-1.459.926-1.459S69.112,41.334,69.112,42.159Z"
              transform="translate(-24.595 -14.882)"
              fill="#053a3d"
            />
            <path
              id="Pfad_291"
              data-name="Pfad 291"
              d="M86.489,42.159c0,.806-.419,1.459-.926,1.459s-.933-.634-.933-1.459.419-1.459.933-1.459S86.489,41.334,86.489,42.159Z"
              transform="translate(-30.947 -14.882)"
              fill="#053a3d"
            />
            <path
              id="Pfad_292"
              data-name="Pfad 292"
              d="M87.941,34.963s-3.832-1.522-6.781-.254l.292,1.643s4.333-.368,6.515.514A2.842,2.842,0,0,0,87.941,34.963Z"
              transform="translate(-29.678 -12.507)"
              fill="#053a3d"
            />
            <path
              id="Pfad_293"
              data-name="Pfad 293"
              d="M63.027,34.97s3.857-1.529,6.832-.26l-.3,1.649S65.2,35.991,63,36.886A2.855,2.855,0,0,1,63.027,34.97Z"
              transform="translate(-22.983 -12.507)"
              fill="#053a3d"
            />
            <path
              id="Pfad_294"
              data-name="Pfad 294"
              d="M77.029,48.58A3.806,3.806,0,0,0,78.3,48.3a.355.355,0,0,0-.273-.634,2.138,2.138,0,0,1-1.44.133.393.393,0,0,1-.178-.33c-.127-1.269.216-5.449.216-5.494a.355.355,0,0,0-.324-.387.362.362,0,0,0-.387.33,52.65,52.65,0,0,0-.216,5.62,1.1,1.1,0,0,0,.52.875,1.5,1.5,0,0,0,.812.165Z"
              transform="translate(-27.678 -15.207)"
              fill="#7b4b2a"
            />
            <path
              id="Pfad_295"
              data-name="Pfad 295"
              d="M70.59,56.44c.273,1.37,1.18,3.889,4.225,3.889s3.914-2.3,4.206-3.889Z"
              transform="translate(-25.813 -20.637)"
              fill="#fff"
            />
            <path
              id="Pfad_296"
              data-name="Pfad 296"
              d="M83.573,27.785A72.416,72.416,0,0,1,82.59,37.3l-1.6-.114s.387-2.474.565-4.085.488-4.631-.888-5.005-.571-3.806-2.48-5.3-6.153-2.785-8.976-1.066-6.02.774-7.327,1.078S58.82,24.892,59.3,26.567s-.952,2.69-1.269,4.441S58.8,37.4,58.8,37.4l-1.535.3a54.017,54.017,0,0,1-.768-10.346,7.872,7.872,0,0,1,4-6.718c6.566-3.724,13.493-2.334,18.054-.584A7.866,7.866,0,0,1,83.573,27.785Z"
              transform="translate(-20.654 -6.686)"
              fill="#053a3d"
            />
            <path
              id="Pfad_297"
              data-name="Pfad 297"
              d="M91.56,189.44A127.112,127.112,0,0,1,69.8,193.012l-.983.07c-1,.07-2,.127-2.994.171A124.235,124.235,0,0,1,51,193c-1-.076-1.986-.165-2.988-.266l-.952-.1a129.9,129.9,0,0,1-17.692-3.172c-.063-5.436,0-22.621.343-41.233.038-2.239.076-4.5.127-6.762.527-24.562,1.535-49.48,3.349-52.018,1.738-2.392,6.978-5.43,12-8.171l.894-.488,3.261-1.77A61.535,61.535,0,0,0,54.659,75.9v.691s2.7,3.571,5.709,3.311c2.772-.241,4.885-3.445,5.24-4.016a70.193,70.193,0,0,0,6.382,3.629l2.341,1.269.882.469c5.544,2.937,11.52,6.255,13.322,8.716a3.063,3.063,0,0,1,.387.907c1.059,3.6,1.719,15.523,2.119,29.967V121c0,.584,0,1.174.044,1.764V123c.133,5.075.235,10.4.311,15.764v1.9l.038,3.172v2.322C91.719,165.474,91.643,183.75,91.56,189.44Z"
              transform="translate(-10.732 -27.749)"
              fill={color}
            />
            <path
              id="Pfad_298"
              data-name="Pfad 298"
              d="M121.939,142.184c-1.744-2.848-3.616-5.76-5.386-8.329h0c-.742-1.085-1.459-2.106-2.144-3.039l-.038-.044-.634-.856a.635.635,0,0,1-.076-.146h0a.482.482,0,0,1,.844-.425c2.119,2.81,4.834,6.851,7.4,10.949v.152C121.913,141,121.926,141.594,121.939,142.184Z"
              transform="translate(-41.555 -47.226)"
              fill="#0a777d"
            />
            <path
              id="Pfad_299"
              data-name="Pfad 299"
              d="M44.821,208.693h0a.5.5,0,0,1-.476-.514c.577-16.189-7.815-21.429-7.9-21.479a.5.5,0,0,1,.507-.85,14.85,14.85,0,0,1,4.441,4.853c1.96,3.172,4.231,8.754,3.92,17.508a.5.5,0,0,1-.488.482Z"
              transform="translate(-13.239 -67.929)"
              fill="#0a777d"
            />
            <path
              id="Pfad_300"
              data-name="Pfad 300"
              d="M105.932,182.021a.5.5,0,0,1-.495-.457c-.266-3.406.856-5.893,2.277-9.046.419-.92.844-1.871,1.269-2.937,2.759-6.692,1.37-14.343,1.358-14.419a.495.495,0,1,1,.971-.178c.063.324,1.453,8.012-1.415,14.971-.444,1.085-.882,2.043-1.269,2.975-1.415,3.134-2.436,5.4-2.195,8.557a.488.488,0,0,1-.45.533Z"
              transform="translate(-38.54 -56.507)"
              fill="#0a777d"
            />
            <path
              id="Pfad_301"
              data-name="Pfad 301"
              d="M60.86,78.987c.216,1.592.527,3.66.863,6.007.1.7.209,1.421.311,2.163.343,2.43.7,5.075,1,7.733.082.717.159,1.44.235,2.15.266,2.645.469,5.272.539,7.707v2.157a34.32,34.32,0,0,1-.33,5.075c-.146.92-.273,1.827-.387,2.709-.1.736-.178,1.459-.254,2.163-.285,2.753-.431,5.316-.469,7.733v2.157c0,2.74.178,5.3.4,7.727.07.73.146,1.446.222,2.151.292,2.658.634,5.189,1,7.695l.285,2.144c.146,1.142.285,2.29.406,3.438s.209,2.652.247,4.231v2.163c0,2.366-.051,4.992-.159,7.733,0,.717-.063,1.44-.1,2.176-.127,2.537-.285,5.17-.469,7.752-.051.729-.1,1.453-.159,2.176-.2,2.69-.419,5.316-.634,7.752-.063.742-.133,1.465-.2,2.169-.26,2.683-.507,5.075-.73,6.978a124.225,124.225,0,0,0,14.819.254c.114-2.03.431-5.3.736-9.147q.089-1.053.171-2.17c.184-2.449.355-5.075.463-7.7q.044-1.085.076-2.17c.076-2.639.076-5.252-.038-7.707,0-.749-.076-1.472-.133-2.182s-.127-1.434-.209-2.119a42.388,42.388,0,0,1-.317-5.608q0-1.085.057-2.169c.108-2.537.387-5.024.7-7.695.082-.71.171-1.427.26-2.163.285-2.379.584-4.9.818-7.65q.1-1.066.171-2.17c.165-2.366.273-4.91.292-7.676v-2.189c0-2.4-.127-4.961-.324-7.72a3.747,3.747,0,0,0-.051-.749c-.038-.482-.07-.971-.089-1.459a74.11,74.11,0,0,1,.089-7.708c.038-.73.089-1.453.146-2.182.2-2.582.488-5.145.825-7.612.1-.736.2-1.459.3-2.17.406-2.69.844-5.227,1.269-7.492.127-.742.254-1.459.374-2.138.273-1.529.507-2.893.685-4.047A70.191,70.191,0,0,1,77.2,75.86c-.355.571-2.468,3.806-5.24,4.009-3.045.266-5.709-3.305-5.709-3.305v-.691C65,76.7,63.08,77.782,60.86,78.987Z"
              transform="translate(-22.255 -27.738)"
              fill="#fff"
            />
            <path
              id="Pfad_302"
              data-name="Pfad 302"
              d="M62.22,89.132c.1.7.209,1.421.311,2.163a40,40,0,0,0,9.795-1.269,26.11,26.11,0,0,1,10.657-.254c.127-.742.254-1.459.374-2.138a28.248,28.248,0,0,0-11.52.285A37.32,37.32,0,0,1,62.22,89.132Z"
              transform="translate(-22.753 -31.875)"
              fill="#e3e3e3"
            />
            <path
              id="Pfad_303"
              data-name="Pfad 303"
              d="M64.29,104.743c.082.717.159,1.44.235,2.15a43.485,43.485,0,0,0,8.558-1.231,25.8,25.8,0,0,1,9.109-.482c.1-.736.2-1.459.3-2.17a28.482,28.482,0,0,0-9.9.539A41.316,41.316,0,0,1,64.29,104.743Z"
              transform="translate(-23.51 -37.589)"
              fill="#e3e3e3"
            />
            <path
              id="Pfad_304"
              data-name="Pfad 304"
              d="M65.51,120.306v2.157a45.116,45.116,0,0,0,7.993-1.212,26.047,26.047,0,0,1,8.177-.565c.038-.73.089-1.453.146-2.182a28.546,28.546,0,0,0-8.773.634,44.057,44.057,0,0,1-7.543,1.167Z"
              transform="translate(-23.956 -43.294)"
              fill="#e3e3e3"
            />
            <path
              id="Pfad_305"
              data-name="Pfad 305"
              d="M64,138.054a42.155,42.155,0,0,0,8.964-1.269,26.052,26.052,0,0,1,8.247-.571,3.748,3.748,0,0,0-.051-.749c-.038-.482-.07-.971-.089-1.459a28.762,28.762,0,0,0-8.583.672,41.74,41.74,0,0,1-8.247,1.186C64.171,136.627,64.089,137.35,64,138.054Z"
              transform="translate(-23.403 -48.971)"
              fill="#e3e3e3"
            />
            <path
              id="Pfad_306"
              data-name="Pfad 306"
              d="M63.266,153.623a41.474,41.474,0,0,0,9.439-1.269,26.123,26.123,0,0,1,8.564-.552v-2.189a28.546,28.546,0,0,0-9.046.634,39.7,39.7,0,0,1-8.944,1.193C63.26,152.209,63.254,152.932,63.266,153.623Z"
              transform="translate(-23.133 -54.663)"
              fill="#e3e3e3"
            />
            <path
              id="Pfad_307"
              data-name="Pfad 307"
              d="M63.9,167.061c.07.73.146,1.446.222,2.15a42.762,42.762,0,0,0,8.818-1.269,26.21,26.21,0,0,1,8.1-.59q.1-1.066.171-2.17a28.278,28.278,0,0,0-8.761.634,40.816,40.816,0,0,1-8.551,1.243Z"
              transform="translate(-23.367 -60.361)"
              fill="#e3e3e3"
            />
            <path
              id="Pfad_308"
              data-name="Pfad 308"
              d="M65.82,182.643l.285,2.144a47.4,47.4,0,0,0,7.536-1.186,26.193,26.193,0,0,1,7.022-.634c.082-.71.171-1.427.26-2.163a28.546,28.546,0,0,0-7.771.717,44.874,44.874,0,0,1-7.333,1.123Z"
              transform="translate(-24.069 -66.098)"
              fill="#e3e3e3"
            />
            <path
              id="Pfad_309"
              data-name="Pfad 309"
              d="M67.3,198.136V200.3a48.881,48.881,0,0,0,6.851-1.136,26.518,26.518,0,0,1,6.28-.685q0-1.085.057-2.169a29.022,29.022,0,0,0-6.807.749A47.878,47.878,0,0,1,67.3,198.136Z"
              transform="translate(-24.61 -71.778)"
              fill="#e3e3e3"
            />
            <path
              id="Pfad_310"
              data-name="Pfad 310"
              d="M67,215.921a48.016,48.016,0,0,0,7.1-1.161,26.156,26.156,0,0,1,6.921-.634c0-.749-.076-1.472-.133-2.182a28.547,28.547,0,0,0-7.276.736,47.3,47.3,0,0,1-6.521,1.091C67.032,214.462,67,215.185,67,215.921Z"
              transform="translate(-24.5 -77.491)"
              fill="#e3e3e3"
            />
            <path
              id="Pfad_311"
              data-name="Pfad 311"
              d="M66,231.531a46.161,46.161,0,0,0,7.707-1.186,26.446,26.446,0,0,1,6.883-.685q.044-1.085.076-2.169a28.548,28.548,0,0,0-7.447.73,45.344,45.344,0,0,1-7.086,1.135C66.082,230.085,66.032,230.808,66,231.531Z"
              transform="translate(-24.135 -83.174)"
              fill="#e3e3e3"
            />
            <path
              id="Pfad_312"
              data-name="Pfad 312"
              d="M64.63,247.15a43.845,43.845,0,0,0,8.577-1.237,26.083,26.083,0,0,1,6.248-.685q.089-1.053.171-2.169a28.546,28.546,0,0,0-6.908.749,42.857,42.857,0,0,1-7.891,1.174C64.763,245.723,64.693,246.446,64.63,247.15Z"
              transform="translate(-23.634 -88.871)"
              fill="#e3e3e3"
            />
            <path
              id="Pfad_313"
              data-name="Pfad 313"
              d="M91.55,195.872l.99-.07c1.947-11.418.825-28.242.406-33.393a56.418,56.418,0,0,1,2.277-18.853c1.465-5.151.565-17.128-.152-26.7-.2-2.7-.393-5.24-.507-7.333-.368-6.756,2.081-19.266,3.426-25.533l-.882-.469c-1.351,6.2-3.889,18.993-3.5,26.06.114,2.1.3,4.65.507,7.346.71,9.515,1.6,21.378.19,26.364a57.468,57.468,0,0,0-2.315,19.2C92.406,167.643,93.536,184.548,91.55,195.872Z"
              transform="translate(-33.477 -30.538)"
              fill="#0a777d"
            />
            <path
              id="Pfad_314"
              data-name="Pfad 314"
              d="M58,149.336a62.44,62.44,0,0,1,.362,16.9c-.133,1.713-.273,3.476-.368,5.43-.311,6.122-1.345,18.454-1.8,23.788l.958.1c.457-5.335,1.5-17.7,1.8-23.846.1-1.935.235-3.7.374-5.4a63.443,63.443,0,0,0-.381-17.128c-.247-1.535-.514-3.1-.774-4.644-1.269-7.669-2.639-15.605-2-19.405.159-.926.355-1.979.565-3.1.863-4.586,1.935-10.289,1.6-15.225S55.972,88.621,55.2,83.61l-.894.488c.8,5.24,2.728,18.016,3.051,22.78s-.71,10.454-1.58,14.984c-.209,1.123-.412,2.176-.565,3.115-.634,3.958.634,11.615,2,19.722C57.482,146.247,57.742,147.8,58,149.336Z"
              transform="translate(-19.86 -30.571)"
              fill="#0a777d"
            />
            <path
              id="Pfad_315"
              data-name="Pfad 315"
              d="M136.575,78.1s15.58-5.005,20.185-15.225c1.338-2.962-9.649-32.987-9.649-32.987l-5.3.26s1.51,10.429,2.423,16.328c.755,4.859,1.973,10.657,2.379,12.567.089.419.14.634.14.634l-.787.146C138.693,61.3,129.4,66.049,129.4,66.049Z"
              transform="translate(-47.316 -10.929)"
              fill="#935d37"
            />
            <path
              id="Pfad_316"
              data-name="Pfad 316"
              d="M160.221,79.327a.5.5,0,0,0,.7-.108.495.495,0,0,0-.108-.7,39.886,39.886,0,0,0-4.644-2.721c.089.419.14.634.14.634l-.787.146a39.521,39.521,0,0,1,4.7,2.747Z"
              transform="translate(-56.867 -27.716)"
              fill="#7b4b2a"
            />
            <path
              id="Pfad_317"
              data-name="Pfad 317"
              d="M102.615,81.946S97.908,93,109.9,99.156c8.3,4.263,27.214-6.864,27.214-6.864L130.368,78S113.069,85.118,102.615,81.946Z"
              transform="translate(-37.19 -28.52)"
              fill={color}
            />
            <path
              id="Pfad_318"
              data-name="Pfad 318"
              d="M147.366,2.03c-.463.33-.368,2.36-.165,4.276l-.2.032c-.558-2.537-1.662-6.9-2.614-6.064-.634.539.209,4.288.774,6.528l-.349.108c-.691-2.658-2.233-7.777-3.254-6.781-.685.666.634,5.17,1.358,7.473l-.3.114c-.7-2.227-2.189-6.451-3.21-5.455-.92.913,1.725,7.257,1.725,7.257h0l.691,2.537s-.825.355-2.112-1.1-2.829-1.713-1.757.393c1.205,2.385,2.994,4.1,3.806,5.779s3.267,2.246,3.267,2.246L150,19.126s.971-8.412-.888-12.421h0C148.775,4.307,148.21,1.459,147.366,2.03Z"
              transform="translate(-50.312 0)"
              fill="#935d37"
            />
            <path
              id="Pfad_319"
              data-name="Pfad 319"
              d="M19.216,110.05s-9.788,32.657-12.237,44.3-2.595,35.829-2.595,35.829S.109,199.057.008,203.022c-.108,4.212,2.106,7.568,1.852,10.327s3.1,1.269,2.157-4.326,1.744-10.651,2.905-10.486-.964,6.1.07,8.247,2.366-2.017,3.692-4.542c1.383-2.62,1.3-8.335.672-12.414s6.769-28.87,6.807-36.063l9.363-31.648S24.431,108.915,19.216,110.05Z"
              transform="translate(-0.004 -40.214)"
              fill="#935d37"
            />
            <path
              id="Pfad_320"
              data-name="Pfad 320"
              d="M30.813,116.973a83.264,83.264,0,0,1-2.988,10.232h0c-.127.387-.26.774-.387,1.174a.07.07,0,0,0,0,.051c-.381,1.129-.768,2.309-1.174,3.527h0c-1.662,5.075-3.5,10.784-5.043,16.741-.533,2.024-1.028,4.079-1.465,6.122-.565,2.607-1.04,5.208-1.389,7.752-1.269,9.166-3.648,20.782-3.648,20.782-3.508,1.446-9-.463-9-.463s-.146-16.722.634-23.224a173.243,173.243,0,0,1,3.73-20.3c4.206-18.073,11.609-35.759,13.639-40.447l.374-.869h1.751C29.271,100.245,31.714,111.34,30.813,116.973Z"
              transform="translate(-2.091 -35.851)"
              fill={color}
            />
            <path
              id="Pfad_321"
              data-name="Pfad 321"
              d="M5.23,226.55l.279,3.851s5.221,1.7,9.135.5l1.034-3.432A28.946,28.946,0,0,1,5.23,226.55Z"
              transform="translate(-1.915 -82.836)"
              fill="#13dde8"
            />
            <path
              id="Pfad_322"
              data-name="Pfad 322"
              d="M35.941,143.708h0a.546.546,0,0,1,0,.171c-.121.324-.235.634-.355,1a.07.07,0,0,0,0,.051c-.387,1.091-.78,2.277-1.174,3.527h0a188.739,188.739,0,0,0-5.075,19.9q0-1.58.038-3.172c-.533,2.024-1.028,4.079-1.465,6.122a73.137,73.137,0,0,1,1.491-8.037,186.572,186.572,0,0,1,5.671-19.76.482.482,0,0,1,.933.159Z"
              transform="translate(-10.208 -52.36)"
              fill="#0a777d"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}
